import React, { useState } from "react";
import { defineMessages, injectIntl } from "react-intl";
import { string as yupString } from "yup";
import { Error, FormPasswordField } from "cci-component";
import { localize, withRouter } from "cci-utility";

const messages = defineMessages({
  password: {
    id: "password",
    defaultMessage: "Password"
  }
});

/**
 * PasswordComponent for the ApplicationUser Inspect.
 */
const PasswordComponent = ({ intl, ...restProps }) => {
  const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/,
    passwordValidation = yupString().when("fastLogin", (fastLogin, schema) => {
      if (fastLogin) {
        return schema;
      } else {
        schema = schema
          .min(8, "minimum8")
          .matches(passwordRegExp, "invalidPasswordFieldError");
        if (restProps.match.params.id === "new") {
          return schema.required();
        } else {
          return schema;
        }
      }
    }),
    [passwordError, setPasswordError] = useState(null);

  return (
    <React.Fragment>
      <FormPasswordField
        label={messages.password}
        name="password"
        onChangeText={text => {
          passwordValidation
            .validate(text, { abortEarly: false })
            .then(data => setPasswordError())
            .catch(err => {
              if (text) {
                setPasswordError(
                  localize(intl, {
                    id:
                      err.inner[0].type === "required"
                        ? "requiredFieldError"
                        : err.errors[0]
                  })
                );
              } else {
                setPasswordError();
              }
            });
        }}
        // hideError
        error={passwordError}
        {...restProps}
      />
      {/* <Error>{passwordError}</Error> */}
    </React.Fragment>
  );
};

export default injectIntl(withRouter(PasswordComponent));
